module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-10-50ec530629863d39164861b347f32aa6.jpg";